import type { FC } from "react";

import type { CartOverviewTierBenefit } from "./components/BenefitsList";
import { CartOverviewTierCard } from "./components/CartOverviewTierCard";
import { CartOverviewTierContent } from "./components/CartOverviewTierContent";
import { CartOverviewTierProgress } from "./components/CartOverviewTierProgress";

import type { CartOverviewTierSource } from "./context";
import { CartOverviewTierProvider } from "./context";

import styles from "./CartOverviewTier.module.scss";

export type { CartOverviewTierBenefit };

export const CartOverviewTier: FC<CartOverviewTierSource> = (props) => (
  <CartOverviewTierProvider {...props}>
    {props.title || props.descriptionCollapsed || props.descriptionExpanded ? (
      <CartOverviewTierCard />
    ) : (
      <div className={styles.cartOverviewTier} data-testid="cart-overview-tier">
        <CartOverviewTierContent />
        <CartOverviewTierProgress />
      </div>
    )}
  </CartOverviewTierProvider>
);
